import React from 'react';

export const PracticeProviderContext = React.createContext();

export const PracticeProviderContextConsumer = PracticeProviderContext.Consumer;
export const PracticeProviderContextProvider = PracticeProviderContext.Provider;

export function usePracticeProviderContext() {
  return React.useContext(PracticeProviderContext);
}
